import { cn } from "@/lib/utils";
import React from "react";

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const Card = ({ children, className, ...props }: Props) => {
  return (
    <div
      {...props}
      className={cn("bg-background border rounded-lg", className)}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className, ...props }: Props) => {
  return (
    <header
      {...props}
      className={cn("px-6 py-3 border-b card-header", className)}
    >
      {children}
    </header>
  );
};

export default Card;
